import React, { useState } from "react";
import Img from "react-image";
import Loader from "react-loader-spinner";
import styled from "styled-components";
import "./iOS.css";

const Image = styled(Img)`
  transition: all 1s ease;
  transform: scale(1);
  position: absolute;
  z-index: 1;
  object-fit: cover;
  max-width: 100%;
  width: 100%;
  cursor: zoom-in;
  animation: fadeIn 750ms ease-in;
  animation: ${({ isFilteredOption }) =>
    isFilteredOption ? "miniFadeIn 300ms ease-in" : "fadeIn 750ms ease-in"};

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes miniFadeIn {
    0% {
      opacity: 0.7;
    }

    100% {
      opacity: 1;
    }
  }

  &:hover {
    transform: scale(1.04);
    opacity: 0.8;
  }
  }
`;

const ImgWrapper = styled.div`
  width: ${({ isPortait }) => (isPortait ? "240px" : "240px")};
  position: relative;
  z-index: 0;
  background-color: white;
  height: 240px;
  transition: background-color 500ms ease-out;

  &:hover {
    background-color: #dd8a5f;
  }
  }
`;

const LoaderSpinner = styled(Loader)`
  margin-left: 100px;
  margin-top: 100px;
`;

const LoaderWrapper = styled.div`
  height: 240px;
  width: 240px;
  position: absolute;
  background-color: white;
  z-index: 1;
`;

const ImageCaption = styled.div`
  z-index: 3;
  position: absolute;
  background-color: white;
  display: inline-flex;
  bottom: 0;
  right: 0;
  text-align: right;
  font-size: 13px;
  font-family: "Questrial", sans-serif;
  background-color: rgba(0, 0, 0, 0.75);
  color: white;
  cursor: zoom-in;
  pointer-events: none;
  animation: fadeIn 500ms ease-in;
  transition: opacity 250ms ease-in;
  opacity: ${({ fadeCaption }) => (fadeCaption ? 0 : 1)};

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`;

const ThumbnailImageComponent = ({ imageProps, item }) => {
  const [showCaption, setShowCaption] = useState(false);
  const [fadeCaption, setFadeCaption] = useState(false);
  return (
    <ImgWrapper
      className="disableSave"
      onContextMenu={(e) => e.preventDefault()}
      isPortait={item.height < item.width}
      onMouseEnter={() => {
        setFadeCaption(false);
        setShowCaption(true);
      }}
      onMouseLeave={() => {
        setFadeCaption(true);
        setTimeout(() => setShowCaption(false), 250);
      }}
    >
      {showCaption && (
        <ImageCaption fadeCaption={fadeCaption}>
          {item.hoverCaption}
        </ImageCaption>
      )}
      <Image
        {...imageProps}
        isFilteredOption={item.isFilteredOption}
        style={{
          ...imageProps.style,
          cursor: "zoom-in",
        }}
        loader={
          <LoaderWrapper>
            <LoaderSpinner
              type="TailSpin"
              color="#dd8a5f"
              height={40}
              width={40}
            />
          </LoaderWrapper>
        }
      />
    </ImgWrapper>
  );
};

export default ThumbnailImageComponent;
